import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import StarRating from '../components/StarRating';
import { fetchProviderById, submitQuote } from '../api/client';
import { getCategoryBySlug } from '../data/categories';
import { useFavorites } from '../context/FavoritesContext';

export default function ProveedorDetalle() {
  const { id } = useParams();
  const { isFavorite, toggleFavorite } = useFavorites();
  const [provider, setProvider] = useState(null);
  const [loadStatus, setLoadStatus] = useState('loading');
  const [form, setForm] = useState({ nombre: '', telefono: '', mensaje: '' });
  const [sent, setSent] = useState(false);
  const [sendError, setSendError] = useState('');
  const [sending, setSending] = useState(false);
  const [activeImage, setActiveImage] = useState(0);

  useEffect(() => {
    let active = true;
    setLoadStatus('loading');
    fetchProviderById(id)
      .then((data) => {
        if (!active) return;
        setProvider(data);
        setLoadStatus('ready');
      })
      .catch(() => active && setLoadStatus('error'));
    return () => {
      active = false;
    };
  }, [id]);

  if (loadStatus === 'loading') {
    return <section className="section page-section"><p>Cargando proveedor...</p></section>;
  }

  if (loadStatus === 'error' || !provider) {
    return (
      <section className="section page-section">
        <h1>Proveedor no encontrado</h1>
        <Link to="/categorias" className="btn btn-outline">Volver a categorías</Link>
      </section>
    );
  }

  const category = getCategoryBySlug(provider.category);
  const images = [provider.cover, ...(provider.gallery || [])].filter(Boolean);
  const fav = isFavorite(provider.id);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSendError('');
    setSending(true);
    try {
      await submitQuote({ providerId: provider.id, ...form });
      setSent(true);
    } catch (err) {
      setSendError(err.message || 'No se pudo enviar tu solicitud. Intenta de nuevo.');
    } finally {
      setSending(false);
    }
  };

  return (
    <section className="section page-section provider-detail">
      <nav className="breadcrumb">
        <Link to="/">Inicio</Link> / <Link to={`/categoria/${provider.category}`}>{category?.name}</Link> / {provider.name}
      </nav>

      <div className="provider-detail-header">
        <div>
          <h1>{provider.name}</h1>
          <p className="provider-location">📍 {provider.city}, {provider.state}</p>
          <StarRating rating={provider.rating} reviews={provider.reviews} />
        </div>
        <button
          type="button"
          className={`favorite-btn large ${fav ? 'active' : ''}`}
          onClick={() => toggleFavorite(provider.id)}
        >
          {fav ? '♥ Guardado' : '♡ Guardar en favoritos'}
        </button>
      </div>

      <div className="provider-gallery">
        <img src={images[activeImage]} alt={provider.name} className="gallery-main" />
        <div className="gallery-thumbs">
          {images.map((img, i) => (
            <img
              key={img}
              src={img}
              alt={`${provider.name} ${i + 1}`}
              className={i === activeImage ? 'active' : ''}
              onClick={() => setActiveImage(i)}
            />
          ))}
        </div>
      </div>

      <div className="provider-detail-body">
        <div className="provider-detail-main">
          <h2>Acerca de {provider.name}</h2>
          <p>{provider.description}</p>

          <h2>Paquetes disponibles</h2>
          <div className="packages-grid">
            {(provider.packages || []).map((pkg) => (
              <div className="package-card" key={pkg.name}>
                <h3>{pkg.name}</h3>
                <p className="package-price">${pkg.price.toLocaleString('es-MX')} MXN</p>
                <ul>
                  {pkg.includes.map((item) => <li key={item}>✔ {item}</li>)}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <aside className="provider-detail-sidebar">
          <div className="contact-card">
            <h3>Solicita tu cotización</h3>
            {sent ? (
              <p className="success-message">
                ¡Listo! Enviamos tu solicitud a {provider.name}. Te contactarán muy pronto.
              </p>
            ) : (
              <form onSubmit={handleSubmit}>
                {sendError && <p className="error-message">{sendError}</p>}
                <label>
                  Nombre
                  <input
                    required
                    value={form.nombre}
                    onChange={(e) => setForm({ ...form, nombre: e.target.value })}
                  />
                </label>
                <label>
                  Teléfono
                  <input
                    required
                    value={form.telefono}
                    onChange={(e) => setForm({ ...form, telefono: e.target.value })}
                  />
                </label>
                <label>
                  Mensaje
                  <textarea
                    rows={3}
                    placeholder="Cuéntanos la fecha de tu evento y lo que necesitas..."
                    value={form.mensaje}
                    onChange={(e) => setForm({ ...form, mensaje: e.target.value })}
                  />
                </label>
                <button type="submit" className="btn btn-primary btn-block" disabled={sending}>
                  {sending ? 'Enviando...' : 'Enviar solicitud'}
                </button>
              </form>
            )}
            <a
              href={`https://wa.me/${provider.phone}?text=${encodeURIComponent(`Hola ${provider.name}, vi tu perfil en MisXV.com.mx y me interesa cotizar.`)}`}
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-whatsapp btn-block"
            >
              💬 Contactar por WhatsApp
            </a>
          </div>
        </aside>
      </div>
    </section>
  );
}
